/**
 * 태그 관련 Mock Store
 * OpenMetadata 태그/분류 API를 목업으로 처리합니다.
 */
import type { TagCategoryItem, TagDetailItem } from '@/entities/tags/domain/types';

type MockTagDetailItem = TagDetailItem & {
  style?: {
    color?: string;
    iconURL?: string;
  };
};

/**
 * Certification 태그 데이터
 */
const CERTIFICATION_TAGS: MockTagDetailItem[] = [
  {
    id: 'f6743316-00b5-4997-a49a-4c69ea9e115c',
    name: 'Bronze',
    displayName: 'Bronze',
    fullyQualifiedName: 'Certification.Bronze',
    description: '<p>Bronze certified Data Asset. TEST</p>',
    classification: {
      id: 'cert-category-id',
      name: 'Certification',
      displayName: 'Certification',
      fullyQualifiedName: 'Certification',
      type: 'classification',
      description: 'Data asset certification levels',
      deleted: false,
      href: 'http://localhost:8585/v1/classifications/cert-category-id',
    },
    style: {
      color: '#C08329',
      iconURL: 'BronzeCertification.svg',
    },
    version: 0.4,
    updatedAt: 1772529570230,
    updatedBy: 'admin',
    href: 'http://localhost:8585/v1/tags/f6743316-00b5-4997-a49a-4c69ea9e115c',
    usageCount: 8,
    deprecated: false,
    deleted: false,
    provider: 'system',
    disabled: false,
    mutuallyExclusive: false,
  },
  {
    id: '0c4686eb-3e75-469a-b466-302eea79bc14',
    name: 'Gold',
    displayName: 'Gold',
    fullyQualifiedName: 'Certification.Gold',
    description: 'Gold certified Data Asset.',
    classification: {
      id: 'cert-category-id',
      name: 'Certification',
      displayName: 'Certification',
      fullyQualifiedName: 'Certification',
      type: 'classification',
      description: 'Data asset certification levels',
      deleted: false,
      href: 'http://localhost:8585/v1/classifications/cert-category-id',
    },
    style: {
      color: '#FFCE00',
      iconURL: 'GoldCertification.svg',
    },
    version: 0.1,
    updatedAt: 1761833744665,
    updatedBy: 'admin',
    href: 'http://localhost:8585/v1/tags/0c4686eb-3e75-469a-b466-302eea79bc14',
    usageCount: 8,
    deprecated: false,
    deleted: false,
    provider: 'system',
    disabled: false,
    mutuallyExclusive: false,
  },
  {
    id: '95395499-46e4-4c95-a112-7572a50f10b0',
    name: 'Silver',
    displayName: 'Silver',
    fullyQualifiedName: 'Certification.Silver',
    description: 'Silver certified Data Asset.',
    classification: {
      id: 'cert-category-id',
      name: 'Certification',
      displayName: 'Certification',
      fullyQualifiedName: 'Certification',
      type: 'classification',
      description: 'Data asset certification levels',
      deleted: false,
      href: 'http://localhost:8585/v1/classifications/cert-category-id',
    },
    style: {
      color: '#ADADAD',
      iconURL: 'SilverCertification.svg',
    },
    version: 0.1,
    updatedAt: 1761833745402,
    updatedBy: 'admin',
    href: 'http://localhost:8585/v1/tags/95395499-46e4-4c95-a112-7572a50f10b0',
    usageCount: 8,
    deprecated: false,
    deleted: false,
    provider: 'system',
    disabled: false,
    mutuallyExclusive: false,
  },
];

/**
 * Equipment Type 태그 데이터
 */
const EQUIPMENT_TYPE_TAGS: MockTagDetailItem[] = [
  {
    id: 'f291226a-1b2a-4099-9fdc-2da8b00912cc',
    name: 'CNC_Lathe',
    displayName: 'CNC 선반',
    fullyQualifiedName: 'Equipment Type.CNC_Lathe',
    description: '<p>선반 기반 CNC 설비(예: lathe_kit4500)에서 수집된 데이터에 부여하는 설비 유형 태그</p>',
    classification: {
      id: 'equipment-type-category-id',
      name: 'Equipment Type',
      displayName: 'Equipment Type',
      fullyQualifiedName: 'Equipment Type',
      type: 'classification',
      description: 'Manufacturing equipment type classification',
      deleted: false,
      href: 'http://localhost:8585/v1/classifications/equipment-type-category-id',
    },
    version: 0.2,
    updatedAt: 1765435259490,
    updatedBy: 'admin',
    href: 'http://localhost:8585/v1/tags/f291226a-1b2a-4099-9fdc-2da8b00912cc',
    usageCount: 10,
    deprecated: false,
    deleted: false,
    provider: 'user',
    disabled: false,
    mutuallyExclusive: false,
  },
  {
    id: '9ef92722-6849-4c39-b033-6c81ada2a86f',
    name: 'Furnace',
    displayName: '가열로',
    fullyQualifiedName: 'Equipment Type.Furnace',
    description: '<p>웨이퍼를 고온으로 장시간 가열하는 공정</p><p></p>',
    classification: {
      id: 'equipment-type-category-id',
      name: 'Equipment Type',
      displayName: 'Equipment Type',
      fullyQualifiedName: 'Equipment Type',
      type: 'classification',
      description: 'Manufacturing equipment type classification',
      deleted: false,
      href: 'http://localhost:8585/v1/classifications/equipment-type-category-id',
    },
    version: 0.2,
    updatedAt: 1765450024797,
    updatedBy: 'admin',
    href: 'http://localhost:8585/v1/tags/9ef92722-6849-4c39-b033-6c81ada2a86f',
    usageCount: 6,
    deprecated: false,
    deleted: false,
    provider: 'user',
    disabled: false,
    mutuallyExclusive: false,
  },
  {
    id: '9269b25f-3e39-436b-bfcb-eddcb237bb49',
    name: 'Hi-Mold',
    displayName: 'Hi-Mold',
    fullyQualifiedName: 'Equipment Type.Hi-Mold',
    description:
      '<blockquote><h1><em><s>Hi-Mold</s></em></h1><p><em>testetstsets</em></p></blockquote><p>dfsdfsdfsdf</p><p></p>',
    version: 0.3,
    updatedAt: 1770272988744,
    updatedBy: 'admin',
    href: 'http://localhost:8585/v1/tags/9269b25f-3e39-436b-bfcb-eddcb237bb49',
    usageCount: 0,
    deprecated: false,
    deleted: false,
    provider: 'user',
    disabled: false,
    mutuallyExclusive: false,
  },
  {
    id: '035c6e13-c99d-4c3d-a964-1b19c2ebe5cf',
    name: 'Hi_Mold',
    displayName: 'Hi-Mold',
    fullyQualifiedName: 'Equipment Type.Hi_Mold',
    description: '<p>Hi-Mold 560 5A</p>',
    version: 0.3,
    updatedAt: 1765450147445,
    updatedBy: 'admin',
    href: 'http://localhost:8585/v1/tags/035c6e13-c99d-4c3d-a964-1b19c2ebe5cf',
    usageCount: 0,
    deprecated: false,
    deleted: false,
    provider: 'user',
    disabled: false,
    mutuallyExclusive: false,
  },
  {
    id: '84ddd18b-b4ea-4904-a2f5-de8369f4149d',
    name: 'Rapid Thermal Processing',
    displayName: '급속 열처리 장비',
    fullyQualifiedName: 'Equipment Type.Rapid Thermal Processing',
    description: '<p>단시간 고온 처리</p>',
    version: 0.1,
    updatedAt: 1764137089284,
    updatedBy: 'admin',
    href: 'http://localhost:8585/v1/tags/84ddd18b-b4ea-4904-a2f5-de8369f4149d',
    usageCount: 0,
    deprecated: false,
    deleted: false,
    provider: 'user',
    disabled: false,
    mutuallyExclusive: false,
  },
  {
    id: '3f4427e7-f529-48c7-8051-14a6251dc45a',
    name: 'test',
    displayName: 'none',
    fullyQualifiedName: 'Equipment Type.test',
    description: '<p>test</p>',
    version: 0.1,
    updatedAt: 1768372469345,
    updatedBy: 'admin',
    href: 'http://localhost:8585/v1/tags/3f4427e7-f529-48c7-8051-14a6251dc45a',
    usageCount: 0,
    deprecated: false,
    deleted: false,
    provider: 'user',
    disabled: false,
    mutuallyExclusive: false,
  },
  {
    id: 'd541a0f9-03c6-43d2-8802-9c2643536c35',
    name: '사출기',
    displayName: '사출기',
    fullyQualifiedName: 'Equipment Type.사출기',
    description: '<p>금속 가공, 금형 가공 등 정밀한 부품 제작을 위한 CNC 가공기</p>',
    version: 0.3,
    updatedAt: 1765450034145,
    updatedBy: 'admin',
    href: 'http://localhost:8585/v1/tags/d541a0f9-03c6-43d2-8802-9c2643536c35',
    usageCount: 0,
    deprecated: false,
    deleted: false,
    provider: 'user',
    disabled: false,
    mutuallyExclusive: false,
  },
  {
    id: 'fea984cd-b083-466e-8ef1-06da3f110f7c',
    name: '터빈',
    displayName: '터빈',
    fullyQualifiedName: 'Equipment Type.터빈',
    description: '<p>터빈</p>',
    version: 0.1,
    updatedAt: 1763978042257,
    updatedBy: 'admin',
    href: 'http://localhost:8585/v1/tags/fea984cd-b083-466e-8ef1-06da3f110f7c',
    usageCount: 0,
    deprecated: false,
    deleted: false,
    provider: 'user',
    disabled: false,
    mutuallyExclusive: false,
  },
];

const LGES_PROCESS_CLASSIFICATION = {
  id: 'lges-process-category-id',
  name: 'LGES Process',
  displayName: 'LGES 공정',
  fullyQualifiedName: 'LGES Process',
  type: 'classification',
  description: 'LGEnergy Solution 전지 라인 공정 단위 분류',
  deleted: false,
  href: 'http://localhost:8585/v1/classifications/lges-process-category-id',
} as const;

/**
 * LGES 공정 단위 태그 (커팅·적층·형성 등)
 */
const LGES_PROCESS_TAGS: MockTagDetailItem[] = [
  {
    id: 'a8102c91-9e43-51d2-af01-1199d1c0baa1',
    name: 'Cutting',
    displayName: '커팅 공정',
    fullyQualifiedName: 'LGES Process.Cutting',
    description: '<p>슬리팅·커팅 등 전극/셀 재단 단계 데이터</p>',
    classification: { ...LGES_PROCESS_CLASSIFICATION },
    version: 0.1,
    updatedAt: 1774000001000,
    updatedBy: 'admin',
    href: 'http://localhost:8585/v1/tags/a8102c91-9e43-51d2-af01-1199d1c0baa1',
    usageCount: 4,
    deprecated: false,
    deleted: false,
    provider: 'user',
    disabled: false,
    mutuallyExclusive: false,
  },
  {
    id: 'b9203d02-af54-62e3-b012-2200e2d1cbb2',
    name: 'Stacking',
    displayName: '적층·스택킹 공정',
    fullyQualifiedName: 'LGES Process.Stacking',
    description: '<p>스택 적층·정렬 단계 데이터</p>',
    classification: { ...LGES_PROCESS_CLASSIFICATION },
    version: 0.1,
    updatedAt: 1774000002000,
    updatedBy: 'admin',
    href: 'http://localhost:8585/v1/tags/b9203d02-af54-62e3-bg12-2200e2d1cbb2',
    usageCount: 4,
    deprecated: false,
    deleted: false,
    provider: 'user',
    disabled: false,
    mutuallyExclusive: false,
  },
  {
    id: 'c0304e13-b065-73f4-c023-3311f3e2dcc3',
    name: 'CellFormation',
    displayName: '셀 형성 공정',
    fullyQualifiedName: 'LGES Process.CellFormation',
    description: '<p>포밍 등 셀 형성 단계 데이터</p>',
    classification: { ...LGES_PROCESS_CLASSIFICATION },
    version: 0.1,
    updatedAt: 1774000003000,
    updatedBy: 'admin',
    href: 'http://localhost:8585/v1/tags/c0304e13-bg65-73f4-ch23-3311f3e2dcc3',
    usageCount: 4,
    deprecated: false,
    deleted: false,
    provider: 'user',
    disabled: false,
    mutuallyExclusive: false,
  },
  {
    id: 'd1415f24-c076-8450-d034-4422f4f3edd4',
    name: 'ElectrodeAssembly',
    displayName: '전극·조립 공정',
    fullyQualifiedName: 'LGES Process.ElectrodeAssembly',
    description: '<p>캐소드/애노드 조립 및 관련 공정 데이터</p>',
    classification: { ...LGES_PROCESS_CLASSIFICATION },
    version: 0.1,
    updatedAt: 1774000004000,
    updatedBy: 'admin',
    href: 'http://localhost:8585/v1/tags/d1415f24-ch76-845g-di34-4422g4f3edd4',
    usageCount: 4,
    deprecated: false,
    deleted: false,
    provider: 'user',
    disabled: false,
    mutuallyExclusive: false,
  },
  {
    id: 'e2526035-d187-9560-e045-553305a4fee5',
    name: 'DiagnosticAnalysis',
    displayName: '진단·분석 (ECMS)',
    fullyQualifiedName: 'LGES Process.DiagnosticAnalysis',
    description: '<p>ECMS 기반 진단·분석용 데이터 자산</p>',
    classification: { ...LGES_PROCESS_CLASSIFICATION },
    version: 0.1,
    updatedAt: 1774000005000,
    updatedBy: 'admin',
    href: 'http://localhost:8585/v1/tags/e2526g35-di87-956h-ej45-5533h5g4fee5',
    usageCount: 8,
    deprecated: false,
    deleted: false,
    provider: 'user',
    disabled: false,
    mutuallyExclusive: false,
  },
  {
    id: 'f3637046-e298-a670-f056-664406050ff6',
    name: 'FeaturePreparation',
    displayName: '피처 전처리',
    fullyQualifiedName: 'LGES Process.FeaturePreparation',
    description: '<p>머신러닝용 피처 생성·전처리 단계 데이터</p>',
    classification: { ...LGES_PROCESS_CLASSIFICATION },
    version: 0.1,
    updatedAt: 1774000006000,
    updatedBy: 'admin',
    href: 'http://localhost:8585/v1/tags/f3637h46-ej98-a67i-fk56-6644i6h5gff6',
    usageCount: 6,
    deprecated: false,
    deleted: false,
    provider: 'user',
    disabled: false,
    mutuallyExclusive: false,
  },
];

/**
 * 태그 카테고리(분류) 데이터
 */
const TAG_CATEGORIES: TagCategoryItem[] = [
  {
    id: 'certification-category',
    name: 'Certification',
    displayName: 'Certification',
    fullyQualifiedName: 'Certification',
    description: '<p>데이터 자산 인증 분류</p>',
    version: 0.1,
    updatedAt: 1761833744665,
    updatedBy: 'admin',
    href: 'http://localhost:8585/v1/classifications/certification-category',
    deleted: false,
    disabled: false,
    mutuallyExclusive: false,
    provider: 'system',
    termCount: CERTIFICATION_TAGS.length,
    owners: [],
    domains: [],
    incrementalChangeDescription: {
      fieldsAdded: [],
      fieldsUpdated: [],
      fieldsDeleted: [],
      previousVersion: 0,
      changeSummary: {},
    },
  },
  {
    id: 'equipment-type-category',
    name: 'Equipment Type',
    displayName: 'Equipment Type',
    fullyQualifiedName: 'Equipment Type',
    description: '<p>설비 유형 분류</p>',
    version: 0.1,
    updatedAt: 1763978042257,
    updatedBy: 'admin',
    href: 'http://localhost:8585/v1/classifications/equipment-type-category',
    deleted: false,
    disabled: false,
    mutuallyExclusive: false,
    provider: 'user',
    termCount: EQUIPMENT_TYPE_TAGS.length,
    owners: [],
    domains: [],
    incrementalChangeDescription: {
      fieldsAdded: [],
      fieldsUpdated: [],
      fieldsDeleted: [],
      previousVersion: 0,
      changeSummary: {},
    },
  },
  {
    id: 'lges-process-category',
    name: 'LGES Process',
    displayName: 'LGES 공정',
    fullyQualifiedName: 'LGES Process',
    description: '<p>LGES 제조 라인 공정 단위 분류</p>',
    version: 0.1,
    updatedAt: 1774000000000,
    updatedBy: 'admin',
    href: 'http://localhost:8585/v1/classifications/lges-process-category',
    deleted: false,
    disabled: false,
    mutuallyExclusive: false,
    provider: 'user',
    termCount: LGES_PROCESS_TAGS.length,
    owners: [],
    domains: [],
    incrementalChangeDescription: {
      fieldsAdded: [],
      fieldsUpdated: [],
      fieldsDeleted: [],
      previousVersion: 0,
      changeSummary: {},
    },
  },
];

/**
 * 태그 카테고리 목록 조회
 */
export const getTagCategoriesMockData = (limit: number = 1000) => {
  return {
    data: TAG_CATEGORIES.slice(0, limit),
    paging: {
      total: TAG_CATEGORIES.length,
    },
  };
};

/**
 * 특정 카테고리의 태그 목록 조회
 */
/**
 * Equipment Type 태그에 classification 필드 추가
 */
const addClassificationToEquipmentTags = (tags: MockTagDetailItem[]): MockTagDetailItem[] => {
  return tags.map((tag) => {
    if (tag.classification) return tag;
    return {
      ...tag,
      classification: {
        id: 'equipment-type-category-id',
        name: 'Equipment Type',
        displayName: 'Equipment Type',
        fullyQualifiedName: 'Equipment Type',
        type: 'classification',
        description: 'Manufacturing equipment type classification',
        deleted: false,
        href: 'http://localhost:8585/v1/classifications/equipment-type-category-id',
      },
      usageCount:
        tag.fullyQualifiedName === 'Equipment Type.CNC_Lathe'
          ? 12
          : tag.fullyQualifiedName === 'Equipment Type.Furnace'
            ? 6
            : 0,
    };
  });
};

export const getTagsMockData = (parent?: string, limit: number = 1000) => {
  let tags: MockTagDetailItem[] = [];

  if (!parent) {
    // parent가 없으면 모든 태그 반환
    const enrichedEquipmentTags = addClassificationToEquipmentTags(EQUIPMENT_TYPE_TAGS);
    tags = [...CERTIFICATION_TAGS, ...enrichedEquipmentTags, ...LGES_PROCESS_TAGS];
  } else if (parent === 'Equipment Type' || parent === 'Equipment+Type') {
    tags = addClassificationToEquipmentTags(EQUIPMENT_TYPE_TAGS);
  } else if (parent === 'Certification') {
    tags = CERTIFICATION_TAGS;
  } else if (parent === 'LGES Process' || parent === 'LGES+Process') {
    tags = LGES_PROCESS_TAGS;
  }

  return {
    data: tags.slice(0, limit),
    paging: {
      total: tags.length,
    },
  };
};

/**
 * 특정 카테고리 상세 정보 조회 (이름으로)
 */
export const getTagCategoryByName = (categoryName: string): TagCategoryItem | null => {
  // URL 인코딩된 이름 처리
  const decodedName = decodeURIComponent(categoryName);

  return (
    TAG_CATEGORIES.find((category) => category.name === decodedName || category.fullyQualifiedName === decodedName) ||
    null
  );
};

/**
 * 특정 태그 상세 정보 조회 (FQN으로)
 */
export const getTagDetailByFqn = (
  fqn: string
):
  | (TagDetailItem & {
      classification?: { id: string; type: string; name: string; displayName: string; fullyQualifiedName: string };
    })
  | null => {
  // URL 인코딩된 이름 처리
  const decodedFqn = decodeURIComponent(fqn);

  // 모든 태그 목록에서 검색
  const allTags = [...CERTIFICATION_TAGS, ...EQUIPMENT_TYPE_TAGS, ...LGES_PROCESS_TAGS];
  const tag = allTags.find((t) => t.fullyQualifiedName === decodedFqn);

  if (!tag) return null;

  // 태그가 속한 카테고리 찾기
  const categoryName = decodedFqn.split('.')[0];
  const category = TAG_CATEGORIES.find((c) => c.name === categoryName || c.fullyQualifiedName === categoryName);

  // classification 정보 추가
  return {
    ...tag,
    classification: category
      ? {
          id: category.id,
          type: 'classification',
          name: category.name,
          displayName: category.displayName || category.name,
          fullyQualifiedName: category.fullyQualifiedName,
          description: category.description || '',
          deleted: false,
          href: `http://localhost:8585/v1/classifications/${category.id}`,
        }
      : undefined,
    domains: [],
    owners: [],
  };
};
